import {AlternativeCampaignBlock} from 'components/blocks/Headers/AlternativeCampaignBlock';
import {CampaignHeaderBlock} from 'components/blocks/Headers/CampaignHeaderBlock';
import {CenterAlignBlock} from 'components/blocks/Headers/CenterAlignBlock';
import {CtaHeaderBlock} from 'components/blocks/Headers/CtaHeaderBlock';
import {LeftAlignHeaderBlock} from 'components/blocks/Headers/LeftAlignHeaderBlock';
import React from 'react';
import {IContentBlock} from 'features/blocks/types';

export const getHeaderBlock = (headerBlock: IContentBlock<any>) => { // eslint-disable-line @typescript-eslint/no-explicit-any -- polymorphic block dispatch

    if(headerBlock === null) return null;

    switch (headerBlock.component) {
        case 'left-align-header-block':
            return <LeftAlignHeaderBlock {...headerBlock} />;
        case 'campaign-header-block':
            return <CampaignHeaderBlock {...headerBlock} />;
        case 'alternative-campaign-header-block':
            return <AlternativeCampaignBlock {...headerBlock} />;
        case 'cta-header-block':
            return <CtaHeaderBlock {...headerBlock} />;
        case 'center-align-header-block':
            return <CenterAlignBlock {...headerBlock} />;
        default:
            return null;
    }
};
